/* Optional visual enhancement. Content is visible before and without this script. */
document.addEventListener('DOMContentLoaded', () => {
  function animate(element, frames, options = {}) {
    if (!element?.animate) return null;
    try {
      return element.animate(frames, {duration:650,easing:'cubic-bezier(.16,1,.3,1)',...options});
    } catch { return null; }
  }
  const reveal = (element, delay = 0) => animate(element,
    [{opacity:0,transform:'translateY(16px)'},{opacity:1,transform:'translateY(0)'}],
    {delay,fill:'backwards'});
  document.querySelectorAll('.hero-content > *').forEach((element,index) => reveal(element,index*70));
  if (!('IntersectionObserver' in window)) return;
  const seen = new WeakSet();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting || seen.has(entry.target)) return;
      seen.add(entry.target);
      observer.unobserve(entry.target);
      const siblings = Array.from(entry.target.parentElement.children).filter(el => el.classList.contains('product-card'));
      reveal(entry.target, siblings.length ? (siblings.indexOf(entry.target)%4)*60 : 0);
    });
  },{threshold:0.08});
  document.querySelectorAll('.product-card, .collection-page h1, .page-container h1, .page-content, .footer-grid').forEach(element => observer.observe(element));
});
